module.exports = __webpack_public_path__ + "static/media/weekend_cropped.e0876bdd.webp";